module.exports = ".notifier {\n  height: 0;\n  overflow: hidden;\n}\n"